import { defineStore } from 'pinia';

interface INotice {
  text: string | null,
  background: string | null
}

export const useNoticeStore = defineStore('noticeStore', {
  state: ():INotice => ({
    text: null,
    background: null,
  }),

  actions: {
    addNotice(notice: INotice) {
      this.text = notice.text
      this.background = notice.background
      setTimeout(() => {
        this.removeNotice()
      }, 4000)
    },
    removeNotice() {
      this.text = null
      this.background = null
    }
  },

  getters: {
    getNoticeText: (state) => state.text,
    getNoticeBackground: (state) => state.background,
    showNotice: (state) => state.text !== null,
  },
});
